import React from 'react';

import dayjs from '~/timeInit';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';

import { pluralizeToString } from '~/utils/stringUtils';

import FieldHistoryTable from './FieldHistoryTable';
import type { FieldHistoryEntry } from './types';

interface Props {
  entries: Array<FieldHistoryEntry>;
  lastUpdatedAt?: string;
  onBack: () => void;
  backLabel: string;
  title: string;
}

export default function FieldHistoryReport({ entries, lastUpdatedAt, onBack, backLabel, title }: Props) {
  return (
    <Stack spacing={2}>
      <Stack direction="row" alignItems="flex-start" justifyContent="space-between">
        <Box>
          <Typography variant="h5">{title}</Typography>
          <Typography variant="body2" color="text.secondary">
            {pluralizeToString('item', entries.length)} · Sorted by Date
            {lastUpdatedAt && ` · Updated ${dayjs(lastUpdatedAt).fromNow()}`}
          </Typography>
        </Box>
        <Button variant="text" startIcon={<ArrowBackIcon />} onClick={onBack}>
          {backLabel}
        </Button>
      </Stack>
      <Paper variant="outlined">
        <FieldHistoryTable entries={entries} />
      </Paper>
    </Stack>
  );
}
